import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View, Text } from 'react-native';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { CustomFileField } from 'root/libs/exaforte/react/Form';
import { withStyles } from '@material-ui/core/styles';
import { FieldSet } from 'root/globals/Form';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
    faTimes,
    faCloudUpload
} from '@fortawesome/pro-light-svg-icons';

library.add(
    faTimes,
    faCloudUpload
);

const FileFieldWrapper = withStyles({
    root: {
        position: 'static',
        
        '& .MuiInput-root': {
            position: 'static'
        }
    }
})(FieldSet);

import defaults from 'root/globals/Defaults.less';
import custom_file_input from './CustomFileInput.less';

const styles = {...defaults, ...custom_file_input};

export default class CustomFileInput extends React.Component {
    constructor(props) {
        super(props);
        
        this._onFileUpload  = this._onFileUpload.bind(this);
        this._renderFile    = this._renderFile.bind(this);
        this.getFileTitle   = this.getFileTitle.bind(this);
        this.getFiles       = this.getFiles.bind(this);
    }
    
    _onFileUpload(files) {
        if(this.props.onChangeText)
            this.props.onChangeText([...(this.props.files || []), ...files]);
    }
    
    _removeFile(file) {
        let files = [...this.props.files];
        let index = files.indexOf(file);
        
        if(index !== -1)
        {
            files.splice(index, 1)
            this.props.onChangeText(files);
        }
    }
    
    _renderFile(file, index) {
        return (
            <View className={['d-flex flex-row justify-content-between mb-1 rounded-sm', styles['background-color-light-grey'], styles['file-input-i']]} key={index}>
                <Text className={['p-1 pl-2 mr-1 font-weight-light', styles['f-1']]}>{this.getFileTitle(file)}</Text>
                <TouchableArea className={['px-2', styles['center-children'], styles['line-height-0-5'], styles['file-input-i-remove']]} onPress={() => this._removeFile(file)}>
                    <FontAwesomeIcon icon={faTimes} className={[styles['f-1'], styles['file-input-i-remove-icon']].join(' ')} />
                </TouchableArea>
            </View>
        );
    }
    
    getFileTitle(file) {
        return file.fileName || file.name;
    }
    
    getFiles() {
        return this.props.files || [];
    }
    
    render() {
        let files       = this.getFiles();
        let has_files   = !_.is_empty(files);
        
        return (
            <>
                {this.props.label && (<Text className={['mb-2', styles['f-1-5'], styles['file-input-label']]}>{this.props.label}</Text>)}
                <View className={['position-relative flex-column', ...(has_files ? ['d-flex p-2'] : ['p-4', styles['center-children']]), styles['background-color-white'], styles['b-1'], styles['b-s-dashed'], styles['border-color-light-grey'], styles['file-input']]}>
                    <CustomFileField onChangeText={this._onFileUpload} inputProps={{ accept: this.props.extensions, multiple: true }} wrapper={FileFieldWrapper} inputRef={this.props.inputRef} />
                    {!has_files ? (
                        <>
                            <FontAwesomeIcon icon={faCloudUpload} className={['mb-1', styles['f-3-2-5'], styles['color-light-grey']].join(' ')} />
                            <Text className={['font-weight-light text-center', styles['f-1-2-5'], styles['color-dark-grey']]}>Sleep je bestand hierheen of zoek in <Text className={['d-inline', styles['color-light-blue']]}>bestanden</Text></Text>
                        </>
                    ) : _.map(files, this._renderFile)}
                </View>
            </>
        );
    }
}
CustomFileInput.defaultProps = { extensions: '.jpg,.gif,.jpeg,.png,.pdf,.xlsx,.docx,.csv' };